import { useTranslation, UseTranslationResponse } from 'react-i18next';

const usePaymentToolsTranslation = (): UseTranslationResponse<'paymentTools'> =>
  useTranslation('paymentTools');

export default usePaymentToolsTranslation;
